export default __webpack_public_path__ + "static/media/sign-out-ico.378a8d55.svg";